import { render } from "./Blog1.vue?vue&type=template&id=c4d2d9c6"
import script from "./Blog1.vue?vue&type=script&lang=js"
export * from "./Blog1.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__